import { cn } from "@/lib/utils";

interface SourceQuoteBlockProps {
  quote: string;
  label?: string;
  className?: string;
}

export function SourceQuoteBlock({
  quote,
  label = "SOURCE QUOTE",
  className,
}: SourceQuoteBlockProps) {
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">
        {label}
      </span>
      <blockquote className="border-l-[3px] border-sand-400 pl-3 text-sm italic text-muted-strong">
        {quote}
      </blockquote>
    </div>
  );
}
